import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";

const Settings = ({
  paused,
  canResume,
  busy,
  onPause,
  onResume,
  onBack,
  loading,
}) => {
  const [confirmOpen, setConfirmOpen] = React.useState(false);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 520, mx: "auto", px: 2, pb: 6 }}>
      <Button size="small" onClick={onBack} sx={{ mb: 2 }}>
        ‹ Matchmaker
      </Button>

      <Typography variant="h6" gutterBottom>
        Matchmaker settings
      </Typography>

      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="subtitle1" gutterBottom>
          {paused ? "Your matchmaker is paused" : "Your matchmaker is active"}
        </Typography>

        {paused ? (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              You are not being considered for matches and we are not emailing
              you. Your profile is still here, exactly as you left it.
            </Typography>
            {canResume ? (
              <Button
                className="tnfm-pill-btn"
                variant="contained"
                fullWidth
                disabled={busy}
                onClick={onResume}
              >
                {busy ? "Working…" : "Turn my matchmaker back on"}
              </Button>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Your matchmaker was paused by the organizer. Reply to any email
                from us and we will get you started again.
              </Typography>
            )}
          </>
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              You are being considered for matches, and we will email you when
              there is one waiting for an answer.
            </Typography>
            <Button
              className="tnfm-pill-btn"
              variant="outlined"
              fullWidth
              disabled={busy}
              onClick={() => setConfirmOpen(true)}
            >
              Pause my matchmaker
            </Button>
          </>
        )}
      </Paper>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Pause your matchmaker?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            If you pause, you will no longer be considered for matches. Any
            matches you have open right now will close. You keep your profile
            and everything in it, and you can turn this back on whenever you
            like.
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600 }}>
            Pausing because you would rather not get the emails?
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            We only email you when someone is waiting on your answer. You have
            been hearing from us because a match has been sitting unanswered,
            and there is a real person on the other side of it who cannot move
            on until you say yes or no.
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            That is why there is no way to stop the emails and stay in the
            matchmaker. Answering your matches stops them too.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            className="tnfm-pill-btn"
            onClick={() => setConfirmOpen(false)}
            disabled={busy}
          >
            Never mind
          </Button>
          <Button
            className="tnfm-pill-btn"
            variant="contained"
            disabled={busy}
            onClick={() => {
              setConfirmOpen(false);
              onPause();
            }}
          >
            Pause my matchmaker
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Settings;
